export default __webpack_public_path__ + "static/media/house.3eeedf29.jpg";